function CTASection() {
  return (
    <section className="bg-black py-12 sm:py-16 px-4 sm:px-8 md:px-20 flex flex-col items-center relative overflow-hidden">

      {/* 🔥 TOP BADGE */}
      <div className="mb-6 z-10">
        <span className="border border-green-400 text-green-400 
        px-4 py-1 rounded-full text-xs sm:text-sm 
        flex items-center gap-2 
        bg-green-400/10 backdrop-blur-md 
        shadow-[0_0_10px_#00ff9f] animate-pulse">
          ⚡ Available 24x7
        </span>
      </div>

      {/* 🔥 Background Glow */}
      <div className="absolute w-[250px] sm:w-[500px] h-[250px] sm:h-[500px] 
      bg-green-400/20 blur-[100px] rounded-full"></div>

      {/* MAIN BOX */}
      <div className="relative z-10 max-w-6xl w-full 
      bg-black/60 border border-green-400/20 
      rounded-2xl 
      p-5 sm:p-8 md:p-12 
      flex flex-col md:flex-row items-center 
      gap-6 sm:gap-8 backdrop-blur-md">

        {/* LEFT */}
        <div className="flex-1 text-center md:text-left">

          <h2 className="text-xl sm:text-3xl md:text-5xl font-bold leading-tight text-white">
            Available 24x7 <span className="text-green-400">Print Instantly.</span>
          </h2>

          <p className="text-gray-400 mt-3 text-sm sm:text-base md:text-lg">
            Print anything in seconds — scan the QR, upload your file, and get it instantly.
          </p>

          <button  onClick={() => window.open("https://app.printezz.com/", "_blank")} className="mt-5 px-5 py-2.5 text-sm sm:text-base 
          bg-green-400 text-black rounded-full 
          transition duration-300 
          shadow-[0_0_15px_#00ff9f] hover:shadow-[0_0_30px_#00ff9f] hover:scale-105">
            Start Printing →
          </button>

        </div>

        {/* RIGHT IMAGE */}
        <div className="flex-1 flex justify-center items-center relative">

          {/* Glow */}
          <div className="absolute w-[120px] h-[120px] 
          bg-green-400/20 blur-2xl rounded-full"></div>

          <img
            src="/assests/home.png" 
            alt="printing"
            className="w-[180px] sm:w-[240px] md:w-[320px] 
            relative z-10 animate-float"
          />

        </div>

      </div>
    </section>
  );
}

export default CTASection;